import { ReactNode } from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import { UserOutlineIcon } from '../../icons/inputIcons'

export interface ClientItem {
  CustomerID: number | string
  Customer_Name: string
  [key: string]: unknown
}

export interface ClientSelectorProps {
  clients: ClientItem[]
  value?: ClientItem | null
  onSelect: (client: ClientItem) => void
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  leadingIcon?: ReactNode | null
  className?: string
}

const ClientSelector: React.FC<ClientSelectorProps> = ({
  clients,
  value,
  onSelect,
  placeholder = 'בחר לקוח',
  disabled,
  readOnly,
  leadingIcon,
  className,
}) => (
  <SearchableSelect<ClientItem>
    items={clients}
    value={value ?? null}
    onSelect={(item) => item && onSelect(item)}
    getKey={(c) => c.CustomerID}
    getLabel={(c) => (c.Customer_Name ?? '').trim()}
    placeholder={placeholder}
    disabled={disabled}
    readOnly={readOnly}
    leadingIcon={leadingIcon === undefined ? <UserOutlineIcon /> : leadingIcon}
    className={className}
    emptyLabel='אין לקוחות מתאימים'
  />
)

export default ClientSelector
